module.exports = __webpack_public_path__ + "img/10-4.d5b29b6a.png";